var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 19H19.5V13.7726C19.5 13.3467 19.1636 13 18.75 13L17 13V14H18.5V20H20.75C20.8881 20 21 19.8881 21 19.75V19.25C21 19.1119 20.8881 19 20.75 19ZM15.8787 12.0158L12.8787 12.793C12.6561 12.8506 12.5 13.0578 12.5 13.2956V19H11.25C11.1119 19 11 19.1119 11 19.25L11 19.75C11 19.8881 11.1119 20 11.25 20H16.5V12.5184C16.5 12.1812 16.1944 11.9339 15.8787 12.0158ZM15.125 16.5C14.918 16.5 14.75 16.2761 14.75 16C14.75 15.7239 14.918 15.5 15.125 15.5C15.332 15.5 15.5 15.7239 15.5 16C15.5 16.2761 15.332 16.5 15.125 16.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.c9e796d11aa2babc9bcb79f9525be3a2.svg";
export { ForwardRef as ReactComponent };